import { TrayArrowDownIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const DownloadBox = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <TrayArrowDownIcon size={Sizes[size]} {...rest} color={fill} />;
};

DownloadBox.displayName = 'DownloadBox';
